import { Modal, csx } from '@vtex/admin-ui'
import { DisclosureState } from 'ariakit'

import React, { ReactNode } from 'react'

interface BottomModalProps {
  state: DisclosureState
  children: ReactNode
  hideOnEsc?: boolean
  hideOnClickOutside?: boolean
}

const BottomModal = ({
  state,
  children,
  hideOnEsc,
  hideOnClickOutside = true,
}: BottomModalProps) => (
  <Modal
    aria-label="bottom-modal"
    state={state}
    hideOnInteractOutside={hideOnClickOutside}
    hideOnEscape={hideOnEsc}
    className={csx({
      margin: '0%',
      width: '100%',
      borderRadius: '16px 16px 0px 0px',
      border: '1px solid #E0E0E0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    })}
  >
    {children}
  </Modal>
)

export default BottomModal
